import { useRef, useState } from "react";
import { UploadCloud, FileText } from "lucide-react";
import { toast } from "sonner";

const MAX = 20 * 1024 * 1024;

export const Dropzone = ({ onFile, compact = false }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);

  const pick = (file) => {
    if (!file) return;
    if (!/\.(pdf|docx)$/i.test(file.name)) return toast.error("Please choose a PDF or DOCX file.");
    if (file.size > MAX) return toast.error("That file is over 20 MB.");
    onFile(file);
  };

  return (
    <div
      data-testid="upload-dropzone"
      onClick={() => input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); pick(e.dataTransfer.files?.[0]); }}
      className={`relative cursor-pointer border border-dashed text-center transition-colors duration-200 ${
        over ? "border-[var(--ink)] bg-[var(--paper-2)]" : "border-[var(--ink-3)] bg-[var(--card)] hover:border-[var(--ink)]"
      } ${compact ? "px-8 py-12" : "px-8 py-16 md:py-20"}`}
    >
      <input ref={input} type="file" accept=".pdf,.docx" className="hidden" data-testid="upload-file-input"
        onChange={(e) => pick(e.target.files?.[0])} />
      <div className="mx-auto w-12 h-12 border border-[var(--rule)] bg-[var(--paper)] grid place-items-center mb-6">
        <UploadCloud className="w-5 h-5" strokeWidth={1.5} />
      </div>
      <p className="eyebrow mb-3">Drop zone</p>
      <h3 className="font-serif-d text-3xl mb-3">Drag your document in</h3>
      <p className="text-sm text-[var(--ink-2)] max-w-sm mx-auto leading-relaxed">
        Or click to browse. We read it, guess what kind of document it is, and line up the right checklist. Up to 20 MB and 50 pages.
      </p>
      <p className="mt-6 inline-flex items-center gap-2 font-mono-d text-xs text-[var(--ink-3)]">
        <FileText className="w-3.5 h-3.5" strokeWidth={1.5} /> PDF / DOCX
      </p>
    </div>
  );
};
